import inboxReducer from "./inboxReducer";

const inboxReducers = {
    inbox: inboxReducer
}

export default inboxReducers;